import axios from "axios";
import store from "@/store";
import router from "./../router";
import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import { Decrypt, Encrypt, GetRandomNum, GetUuid } from "@/utils/aesUtils";
import aesUtils from "@/utils/aesUtils";
import rsaUtils from "@/utils/rsaUtils";
const JsonBig = require("json-bigint")({ storeAsString: true });

import { POR_LOGIN_LOGOUT } from "./config";
const aesKeys = {};
export const requestData = (
  methods,
  url,
  datas,
  responseType,
  headers,
  timeout
) => {
  //封装请求方法
  let EncryptAesKey = "",
    uuid = "";
  if (methods == "post") {
    let randomKey = aesUtils.GetRandomNum();
    let reqData = "";
    if (datas instanceof Object) {
      reqData = JSON.stringify(datas);
    } else {
      reqData = datas;
    }
    datas = {
      data: aesUtils.Encrypt(reqData, randomKey, randomKey),
    };
    EncryptAesKey = rsaUtils.Encrypt(randomKey);
    uuid = aesUtils.GetUuid();
    aesKeys[uuid] = randomKey;
  }

  let headerObj = {};
  headerObj = {
    "Content-Type": "application/json",
    Authorization: "Basic c2FiZXI6c2FiZXJfc2VjcmV0",
    applet: "3",
    i18n: store.state.local || "zh",
    "blade-auth": store.state.userInfo.access_token
      ? "bearer " + store.state.userInfo.access_token
      : "",
    encryptaeskey: EncryptAesKey,
    uuid: uuid,
  };

  if (!datas) datas = {};

  let options = Object.assign(
    {},
    {
      url: url,
      method: methods,
      baseURL: POR_LOGIN_LOGOUT, // config 的 base_url
      timeout: 1 * 60 * 1000, // 超时
      headers: Object.assign(headers || {}, headerObj),
      responseType,
    }
  );

  if (methods == "get") {
    options.params = datas;
  } else if (methods == "post") {
    options.data = datas;
  } else if (methods == "put") {
    options.params = datas;
  } else if (methods == "delete") {
    options.params = datas;
  }
  if (headers) {
    options.headers = headers;
  }
  if (timeout) {
    options.timeout = timeout;
  }

  let listPromise = new Promise((resolve, reject) => {
    axios
      .request(options)
      .then((res) => {
        resolve(res);
      })
      .catch((res) => {
        reject(res);
      });
  });
  return listPromise;
};

axios.interceptors.request.use(
  //请求拦截
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  function (res) {
    if (res.status === 200) {
      if (
        res.config.method == "post" &&
        !(
          res.config.url == "/applet/ANewOrder/getNewOrderExcelByUser"
        )
      ) {
        console.log("走加密", res);
        try {
          let uuid2 = res.config.headers["uuid"];
          let aesKey = aesKeys[uuid2];
          delete aesKeys[uuid2];
          res.data = JsonBig.parse(aesUtils.Decrypt(res.data, aesKey, aesKey));
        } catch (e) {
          Message({
            message:
              store.state.local == "zh"
                ? "返回数据无法解密"
                : "The returned data cannot be decrypted",
            type: "error",
            center: true,
          });
          return false;
        }
      }
      if (res.data.code == 401) {
        loginFunc();
      } else if (res.data.code == 601 || res.data.code == 602) {
        if (
          store.state.user.certifiedAccountOpeningStatus == 0 ||
          store.state.user.certifiedAccountOpeningStatus == 2 ||
          store.state.user.certifiedAccountOpeningStatus == 7
        ) {
          router.push("/userAuth");
        } else if (store.state.user.certifiedAccountOpeningStatus == 1) {
          Message({
            message:
              store.state.local == "zh"
                ? "开户协议签署中，请稍后～"
                : "Account opening agreement is being signed, please wait ~",
            type: "error",
            center: true,
          });
        } else if (store.state.user.certifiedAccountOpeningStatus == 4) {
          Message({
            message:
              store.state.local == "zh"
                ? "企业信息登记中，请稍后～"
                : "Enterprise information registration, please wait ~",
            type: "error",
            center: true,
          });
        }
      }
      console.log(res.config.url + "post返回的结果", res.data);
      return res.data;
    } else if (res.status === 401) {
      loginFunc();
    } else {
    }
  },
  function (error) {
    console.log("error", error);
    if (error.response.status == 401) {
      loginFunc();
    } else {
      // router.push("/error");
    }
  }
);

const loginFunc = () => {
  Message.closeAll();
  Message({
    message:
      store.state.local == "zh"
        ? "登录过期,请重新登录..."
        : "Login expired, please login again...",
    type: "error",
    center: true,
    onClose: function () {
      // Cookies.remove("userInfo");
      store.commit("quitLogin");
      router.replace({
        path: "/login",
      });
    },
  });
};



// WEBPACK FOOTER //
// ./src/request/request.js